import React from "react";
import { Grid, Typography } from "@mui/material";

import Title from "../../ReusableComponents/title";

import { dollarUS } from "../../../utilities/formatters";
import GoldBadge from "../../../assets/images/new_gold_png.png";
import SilverBadge from "../../../assets/images/silver.png";
import BronzeBadge from "../../../assets/images/bronze.png";
import stars_line from "../../../assets/icons/stars.svg";
import "../../../assets/css/dashboard.scss";
const Badge = ({ stage, data }) => {
  const getBadgeImage = () => {
    if (stage.toLowerCase() === "funded") {
      return GoldBadge;
    } else if (stage.toLowerCase() === "evaluation") {
      return SilverBadge;
    } else {
      return BronzeBadge;
    }
  };

  return (
    <Grid className="badge-ctn" item xs={4} height={"100%"} minHeight={"377px"}>
      <div
        style={{ backgroundImage: `url(${getBadgeImage()})`, minHeight:"377px" }}
        className="card"
        width="100%"
      >
        {" "}
        <Grid xs={12} item minHeight={"377px"}>
          <div className="BadgesBox">
            <Title className="mbb-20" six></Title>
            <Grid
              className="BadgeFirst"
              container
              alignItems="center"
              // justifyContent={{ xs: "center", md: "flext-start" }}
              style={{}}
              spacing={2}
              xs={12}
              gap={"50px"}
              sx={{ position: "relative", flexWrap: "nowrap" }}
            >
              {data.photo ? (
                <Grid
                  item
                  xs={12}
                  md={5}
                  lg={3}
                  className="dashboard_user_profile"
                >
                  <div className="dashboard_user_profile">
                    <img
                      src={data.photo}
                      width={70}
                      height={70}
                      style={{ borderRadius: "50%" }}
                      alt=""
                    />
                    {stage.toLowerCase() === "funded" && (
                      <img
                        src={stars_line}
                        alt="star"
                        style={{ marginTop: "-50px" }}
                      />
                    )}
                  </div>
                </Grid>
              ) : (
                false
              )}

              <Grid item maxWidth={"400px"}>
                {/* <img
                  src={
                    data.status === 'Funded'
                      ? ''
                      : data.status === 'Evaluation'
                      ? SilverBadge
                      : BronzeBadge
                  }
                  alt=""
                /> */}

                <Grid item>
                  <div>
                    <Typography
                      component={"h3"}
                      fontWeight={600}
                      fontSize={18}
                      fontFamily={"Outfit"}
                      color={"#ffffff"}
                      sx={{
                        color: "#ffffff !important",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.name}
                    </Typography>
                    <Typography
                      component={"h6"}
                      fontWeight={400}
                      fontSize={15}
                      color={"#FFF"}
                      fontFamily={"Outfit"}
                      sx={{
                        fontSize: "14px",
                        color: "#FFF",
                        fontWeight: "400",
                        opacity: "0.5",
                      }}
                    >
                      {data.status}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              className="BadgeSecond"
              justifyContent={"space-between"}
              padding={"0px 20px"}
              rowSpacing={{ xs: 2, sm: 10, md: 2 }}
            >
              <Grid item md={6} sx={{ paddingTop: "0px !important" }}>
                <Typography
                  component={"h6"}
                  fontWeight={400}
                  fontSize={15}
                  color={"#8B8E93"}
                  fontFamily={"Outfit"}
                >
                  Balance
                </Typography>
                <Typography
                  mt={1}
                  component={"h6"}
                  fontWeight={400}
                  fontSize={15}
                  color={"#8B8E93"}
                  fontFamily={"Outfit"}
                >
                  Account Size
                </Typography>
              </Grid>
              <Grid
                item
                md={5}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}
                sx={{ paddingTop: "0px !important" }}
              >
                <Typography
                  component={"h6"}
                  fontWeight={700}
                  fontSize={16}
                  color={"#FFF"}
                  fontFamily={"Outfit"}
                  textAlign={"end"}
                >
                  {data.balance ? dollarUS(data.balance) : false}
                </Typography>
                <Typography
                  textAlign={"end"}
                  mt={1}
                  component={"h6"}
                  fontWeight={700}
                  fontSize={16}
                  color={"#FFF"}
                  fontFamily={"Outfit"}
                >
                  {data.equity ? dollarUS(data.equity) : false}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </div>
    </Grid>
  );
};

export default Badge;
